import { render, staticRenderFns } from "./OlliPay.vue?vue&type=template&id=2b01f541&scoped=true"
import script from "./OlliPay.vue?vue&type=script&lang=js"
export * from "./OlliPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b01f541",
  null
  
)

export default component.exports